import { render, staticRenderFns } from "./SettingsUserEditBasicView.vue?vue&type=template&id=38ad605f&scoped=true&"
import script from "./SettingsUserEditBasicView.vue?vue&type=script&lang=js&"
export * from "./SettingsUserEditBasicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad605f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ad605f')) {
      api.createRecord('38ad605f', component.options)
    } else {
      api.reload('38ad605f', component.options)
    }
    module.hot.accept("./SettingsUserEditBasicView.vue?vue&type=template&id=38ad605f&scoped=true&", function () {
      api.rerender('38ad605f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/users/edit/SettingsUserEditBasicView.vue"
export default component.exports